// extracted by mini-css-extract-plugin
module.exports = {"dark":"Compost_dark__37pNJ","imageHolder":"Compost_imageHolder__zrb7B","textContainer":"Compost_textContainer__3z8kn","content":"Compost_content__11Aq2"};